import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BarrelPrinter } from '../../_models/fundraising/BarrelPrinter';
import { getUrl } from '../../_shared/utils';
import { JWTTokenService } from '../jwtToken.service';


@Injectable()
export class PrinterService {

  public apiUrl = getUrl();

  constructor(
    private http: HttpClient,
    private jwtTokenService: JWTTokenService) { }

    public getAll(): Observable<BarrelPrinter[]> {
        return this.http.get<BarrelPrinter[]>(getUrl('fundraising/barrel'), this.requestOptionsAuthenticated('portal'));
    }

    public getById(id: number): Observable<BarrelPrinter> {
      return this.http.get<BarrelPrinter>(getUrl(`fundraising/barrel/${id}`), this.requestOptionsAuthenticated('portal'));
    }

    public create(data: BarrelPrinter): Observable<BarrelPrinter> {
      return this.http.post<BarrelPrinter>(getUrl(`fundraising/barrel/create`), data, this.requestOptionsAuthenticated('portal'));
    }

    public update(data: BarrelPrinter): Observable<BarrelPrinter> {
      return this.http.put<BarrelPrinter>(getUrl(`fundraising/barrel/update`), data, this.requestOptionsAuthenticated('portal'));
    }

    public delete(id: number): Observable<any> {
      return this.http.delete<any>(getUrl(`fundraising/barrel/delete/${id}`), this.requestOptionsAuthenticated('portal'));
    }

    private requestOptionsAuthenticated(tokenKey: string) {
        const requestOptions = {
            headers: new HttpHeaders()
                .set('Content-type', 'application/json')
                .append('Authorization', 'Bearer ' + this.jwtTokenService.getToken(tokenKey)),
        };
        return requestOptions;
    }

  }